import React, { useState, useContext, useEffect, Alert } from "react";
import "./profile.css";
import Mobile from "../../component/mobile/mobile";
import carebanner from "../../assets/banner2.jpg";
import {
  ProfileUpdate,
  Locationdetails,
  CheckServiceAvailability,
} from "../../env/action";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Profile() {
  const [preview, setPreview] = useState(null);
  const navigate = useNavigate();
  const { userData, setUserData, token } = useContext(UserContext);
  const user = userData;
  const [fullname, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [locality, setLocality] = useState("");
  const [pincode, setPincode] = useState("");
  const [isServiceAvailable, setIsServiceAvailable] = useState(false);
  const [pincodeError, sertPincodeError] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [image, setImage] = useState(null);
  const [age, setAge] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePincode = (pincode) => {
    setPincode(pincode);
    if (pincode.length !== 6) {
      sertPincodeError("Pincode must be 6 digits");
    } else {
      sertPincodeError("");
    }
  };
  const checkServiceAvailability = (cityName) => {
    if (!cityName) return;

    const params = { city: cityName };

    CheckServiceAvailability(params, (res) => {
      if (res.status === 1) {
        setIsServiceAvailable(true);
      } else {
        setIsServiceAvailable(false);
        alert(res.message, "", [
          {
            text: "OK",
            onPress: () => {
              setPincode(null);
              setCity(null);
              setDistrict(null);
              setState(null);
            },
          },
        ]);
      }
    });
  };

  const fetchLocationDetails = (pincode) => {
    try {
      Locationdetails({ pincode }, (response) => {
        if (!response || typeof response.status === "undefined") {
          console.error("Invalid response from Locationdetails:", response);
          toast.error("Something went wrong. Please try again.");
          return;
        }

        if (
          response.data.city === "" &&
          response.data.district === "" &&
          response.data.state === ""
        ) {
          sertPincodeError("Invalid Pincode");
        } else {
          sertPincodeError("");
        }

        setCity(response.data.city);
        setDistrict(response.data.district);
        setState(response.data.state);

        if (response.data.city) {
          checkServiceAvailability(response.data.city);
        }
      });
    } catch (error) {
      console.error("Error fetching location:", error);
      toast.error("Something went wrong while fetching location data.");
    }
  };
  const convertDateFormatt = (dateStr) => {
    const [dd, mm, yy] = dateStr.split("-");
    return `20${yy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
  };
  useEffect(() => {
    if (user) {
      const formatDobForUI = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year.slice(-2)}`;
      };

      setName(user?.name || "");
      setMobile(user?.phone_number || "");
      setWhatsapp(user?.wp_number?.toString() || "");
      setEmail(user?.email || "");
      setDob(user?.dob || "");
      setState(user?.state || "");
      setDistrict(user?.dist || "");
      setCity(user?.city || "");
      setAddress(user?.address || "");
      setLocality(user?.locality || "");
      setPincode(user?.pincode || "");
      setImage(user?.image || "");
      setPreview(user?.image || "");
      setIsServiceAvailable(true);
      setAge(user?.age || "");
    }
  }, [user]);

  const calculateAge = (dobValue) => {
    const birthDate = new Date(dobValue);
    const today = new Date();
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }

    return calculatedAge;
  };

  const handleDateChange = (e) => {
    const dobValue = e.target.value;
    const calculatedAge = calculateAge(dobValue);

    if (calculatedAge < 18) {
      alert("Age must be 18 or above.");
      setDob("");
      setAge("");
    } else {
      setDob(dobValue);
      setAge(String(calculatedAge));
    }
  };

  const handleSignup = (e) => {
    e.preventDefault();
    if (!isServiceAvailable) {
      alert(
        "Service Unavailable",
        "You cannot proceed as services are not available in this city."
      );
      return;
    }
    const params = {
      name: fullname,
      phone_number: mobile,
      wp_number: whatsapp,
      email: email,
      dob: dob,
      address: address,
      locality: locality,
      pincode: pincode,
      state: state,
      dist: district,
      city: city,
      image: image,
      age: age,
    };
    ProfileUpdate(params, token, async (res) => {
      if (res) {
        if (res.status === 0) {
          toast.error(res.message || "Error");
        } else {
          localStorage.setItem("userData", JSON.stringify(res.data));
          setUserData(res.data);
          navigate("/");
        }
      } else {
        toast.error("Error", "Unexpected response from server.");
      }
    });
  };

  return (
    <>
      <div className="care-banner">
        <img src={carebanner} alt="Care Banner" className="banner-img" />
      </div>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-3">
            <div className="takephoto text-center">
              <div className="profile-pic-wrapper">
                <img
                  src={image}
                  className="profile-pic"
                  alt="Profile Preview"
                />
              </div>
              <input
                type="file"
                accept="image/*"
                id="imageUpload"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />

              <label htmlFor="imageUpload" className="choose-btn">
                Choose Image
              </label>
            </div>
          </div>
          <div className="col-md-9">
            <div className="edit-profile-form p-4 bg-light rounded">
              <h4 className="mb-4">Edit Profile</h4>
              {/* <form> */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">First name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First name"
                    value={fullname}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email id</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email id"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Contact no</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="+91 9876543210"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Whatsapp no</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter your Whatsapp No"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    id="fromDate"
                    className="form-control"
                    value={dob}
                    onChange={handleDateChange}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Age</label>
                  <input
                    type="text"
                    id="age"
                    className="form-control"
                    value={age}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Pin Code</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pincode"
                    name="pincode"
                    value={pincode}
                    minLength="6"
                    maxLength="6"
                    pattern="\d{6}"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setPincode(value);
                        handlePincode(value);
                        if (value.length === 6) {
                          fetchLocationDetails(value);
                        }
                      }
                    }}
                    required
                  />
                </div>
              </div>
              {/* <div className="row mb-3"></div> */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">State</label>
                  <input
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                    placeholder="Enter your state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    readOnly
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">District</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter District"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                    readOnly
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    placeholder="Enter your city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    readOnly
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></textarea>
              </div>
              <div className="mb-3">
                <label className="form-label">Locality</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter Your Locality"
                  value={locality}
                  onChange={(e) => setLocality(e.target.value)}
                ></textarea>
              </div>
              <div className="text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSignup}
                >
                  Submit
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
      <Mobile />
    </>
  );
}
